import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSave = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.75 5.5C2.75 3.98122 3.98122 2.75 5.5 2.75H16.1716C16.9009 2.75 17.6004 3.03973 18.1161 3.55546L20.4445 5.88388C20.9603 6.39961 21.25 7.09908 21.25 7.82843V18.5C21.25 20.0188 20.0188 21.25 18.5 21.25H5.5C3.98122 21.25 2.75 20.0188 2.75 18.5V5.5ZM5.5 4.25C4.80964 4.25 4.25 4.80964 4.25 5.5V18.5C4.25 19.1904 4.80964 19.75 5.5 19.75H5.75V13C5.75 12.0335 6.5335 11.25 7.5 11.25H16.5C17.4665 11.25 18.25 12.0335 18.25 13V19.75H18.5C19.1904 19.75 19.75 19.1904 19.75 18.5V7.82843C19.75 7.49691 19.6183 7.17896 19.3839 6.94454L17.0555 4.61612C16.821 4.3817 16.5031 4.25 16.1716 4.25H15.75V7C15.75 7.9665 14.9665 8.75 14 8.75H8C7.0335 8.75 6.25 7.9665 6.25 7V4.25H5.5ZM12.75 7.25H14C14.1381 7.25 14.25 7.13807 14.25 7V4.25H12.75V7.25ZM11.25 4.25V7.25H8C7.86193 7.25 7.75 7.13807 7.75 7V4.25H11.25ZM16.75 13V19.75H7.25V13C7.25 12.8619 7.36193 12.75 7.5 12.75H16.5C16.6381 12.75 16.75 12.8619 16.75 13Z",
		fill: "currentColor"
	})
});
export { SvgIconSave as ReactComponent };
